<template>
    <section>
    <Header 
    :header_page_data="headerPageData"
    ></Header>
        <ExportRespondentsModal></ExportRespondentsModal>
      <section>
        <div v-if="isOwner(this.$store.getters['currentCampaign'].owner_id)" class="container container-app">
            <section class="position-relative campaigns-container" style="margin-bottom: 80px">
                <div class="row">
                    <div class="col-12">
                        <span class="reports-total-count float-left mb-3 mt-4">{{ respondentsCount }} {{ $t('campaign_reports.locations') }}</span>
                        <div @click.prevent="exportRespondents()" class="export-respondents-btn mb-3 mt-4">{{ $t('campaign_reports.export.export_button') }}</div>
                    </div>
                    <div class="col-12">
                        <span class="add-location-title float-left mb-2">{{ $t('campaign_reports.campaign_reception') }}</span>
                    </div>
                    <div class="col-12">
                        <span class="starRatingReports">
                            <div v-for="n in 5" :key="n">
                                <label class="black-star" v-if="n <= receptionMed"></label>
                                <label class="white-star" v-else></label>
                            </div>
                        </span>
                    </div>
                    <div class="col-12">
                        <span class="starRatingLabels">
                            <span class="float-left ml-2 reception-labels">{{ $t('add_location.annoyed') }}</span><span class="float-right mr-4 reception-labels">{{ $t('add_location.happy') }}</span>
                        </span>
                    </div>
                    <div class="col-12">
                        <span class="add-location-title float-left mt-3">{{ $t('campaign_reports.talking_points') }}</span>
                    </div>
                    <div class="col-12">

                        <div v-for="(question, index) in this.$store.getters['currentCampaign'].questions" class="row mb-3" :key="index">
                            <div class="col-12">
                                <span class="question-text-reports">(Q{{index + 1}}) {{question.text}}</span>
                            </div>
                            <div class="col-12" v-if="question.type != 'open'">
                                <bar-chart
                                    :chart-data="barChartDataQuestions[index]"
                                    :options="barChartOptions"
                                ></bar-chart>
                            </div>
                            <template  v-else>
                                <OpenQuestionResponsesModal :question="question" :index="index"></OpenQuestionResponsesModal>
                                <div data-toggle="modal" :data-target="'#openQuestionResponsesModal' + question._id" class="col-12 view-open-responses margin-top-10">{{ $t('campaign_reports.view_all_responses') }}</div>
                            </template>

                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div v-else class="container container-app">
            <div class="col-12">
                <span class="not-allowed-label w-100 text-center d-block mt-5">{{ $t('campaign_reports.not_allowed') }}</span>
            </div>
        </div>
      </section>
    <CampaignFooter></CampaignFooter>
    </section>
</template>

<script>
    import Header from "../layouts/Header";
    import CampaignFooter from "../layouts/CampaignFooter";
    import HelperMixin from "../../mixins/HelperMixin";
    import BarChart from '../charts/BarChart.vue';
    import OpenQuestionResponsesModal from "../modals/OpenQuestionResponsesModal";
    import ExportRespondentsModal from "../modals/ExportRespondentsModal";

    export default {
        name: "CampaignReports",
        components: {
            ExportRespondentsModal, OpenQuestionResponsesModal, Header, CampaignFooter, BarChart},
        mixins: [HelperMixin],
        data() {
            return {
                barChartDataQuestions: [],
                barChartOptions: {
                    legend: {
                        labels: {
                            filter: function(label) {
                                return false;
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)",
                            },
                            stacked: false,
                            ticks: {
                                autoSkip: false,
                                maxRotation: 90,
                                minRotation: 90
                            }
                        }],
                        yAxes: [{
                            gridLines: {
                                color: "rgba(0, 0, 0, 0)",
                            },
                            stacked: false,
                            ticks: {
                                stepSize: 1,
                                beginAtZero: true
                            }
                        }]
                    }
                },
                headerPageData: {
                    title: this.$store.getters["currentCampaign"].name,
                    search: {
                        show: false,
                        type_search: ''
                    },
                    settings: {
                        show: true,
                        campaign: this.$store.getters["currentCampaign"]
                    },
                    home: {
                        show: true,
                        goto: 'campaign-map'
                    },
                    profile: {
                        show: false
                    }
                },
            }
        },
        created() {
            this.refreshCampaignReports();
            if (typeof this.$store.getters["currentCampaign"].questions != 'undefined') {
                this.setChartsData();
                Chart.pluginService.register({
                    beforeInit: function(chart) {
                        chart.data.labels.forEach(function(e, i, a) {
                            if(typeof e === 'string') {
                                a[i] = e.match(/.{1,30}/g);
                            }
                        });
                    }
                });
            }
        },
        computed: {
            respondentsCount() {
                return typeof this.$store.getters['currentCampaign'].respondents_count != 'undefined' ? this.$store.getters['currentCampaign'].respondents_count : 0;
            },

            receptionMed() {
                if (
                    typeof this.$store.getters['currentCampaign'].reception_sum == 'undefined' || 
                    typeof this.$store.getters['currentCampaign'].respondents_count == 'undefined'
                ) {
                    return 0;
                }
                
                return Math.floor(this.$store.getters['currentCampaign'].reception_sum / this.$store.getters['currentCampaign'].respondents_count);
            }
        },
        methods: {
            refreshCampaignReports() {
                if (this.$store.getters["user"] === null) {
                    if (typeof this.$store.getters["token"] == 'undefined') {
                         this.$router.replace({ name: "login"});
                    }
                    this.refreshData();
                }
            },

            setChartsData() {
                let _this = this;
                this.$store.getters["currentCampaign"].questions.forEach(function(question, indexQ) {
                    var labels = [];
                    var data = [];
                    question.answers.forEach(function(answer, indexA) { 
                        labels.push(answer.text);
                        data.push(typeof answer.responses_count != 'undefined' ? answer.responses_count : 0);
                    });
                    _this.barChartDataQuestions.push({
                        name: question.text,
                        labels: labels,
                        datasets: [{
                                label: '',
                                data: data,
                                backgroundColor: [
                                    '#D6E3F0',
                                    '#FFEAE8',
                                    '#D9EEE5',
                                    '#D6E3F0',
                                    '#FFEAE8',
                                    '#D9EEE5',
                                    '#D6E3F0',
                                    '#FFEAE8',
                                    '#D9EEE5'
                                ],
                                borderColor: [
                                    '#87BFF7',
                                    '#D8ADA9',
                                    '#6ABE9A',
                                    '#87BFF7',
                                    '#D8ADA9',
                                    '#6ABE9A',
                                    '#87BFF7',
                                    '#D8ADA9',
                                    '#6ABE9A'
                                ],
                                borderWidth: 2,
                                hoverBorderWidth: 0
                            }]
                        });
                });
            },
            exportRespondents() {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                axios.post(
                    '/api/v1/campaign/' +  this.$store.getters["currentCampaign"]._id + '/respondent/export',
                    {},
                    config
                ).then(this.consumeExportRespondents, this.errorDefault);
            },
            consumeExportRespondents(response) {
                if (response.data.responseType == "Success") {
                    setTimeout(function () {
                        $('#exportRespondentsModal').modal('show');
                    }, 300);
                }

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },
            errorDefault: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            }
        },
    };
</script>
